import { useAtomValue } from 'jotai';
import { postAtomFamily } from '../posts';

export const usePost = (postId: string) => {
    const post = useAtomValue(postAtomFamily(postId));
    return post;
};
